




































































































































import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { PerfilParmDTO } from '@/interfaces/profiles';
import * as service from '@/services/profiles';
import { ACCESS_TYPE_CLIENT, ACCESS_TYPE_EMEDE, USER_TYPE_DOCTOR, USER_TYPE_OTHER } from '@/settings/consts/users';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: { PermissionAuth }
})
export default class ProfilesForm extends BaseComponent {
  @Prop()
  public isEdit: boolean;
  @Prop()
  public id: number;

  public form: any = {
    valid: false,
    rules: {
      type: [(v) => !!v || 'Selecione um tipo'],
      name: [(v) => !!v || 'Digite um nome para o perfil']
    }
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public item: any = {
    tipo: ACCESS_TYPE_EMEDE,
    ativo: true,
    acessaTodosPerfis: false
  };

  public accessTypes = {
    emede: ACCESS_TYPE_EMEDE,
    client: ACCESS_TYPE_CLIENT
  };

  public userTypes = {
    other: USER_TYPE_OTHER,
    doctor: USER_TYPE_DOCTOR
  };

  formOpen = false;

  features = [];
  featuresSelected = [];
  idsFuncsSelected = [];
  featuresNotSelected = [];
  featureSelecting = null;
  loading = false;

  profilesAccessOptions = [];

  public headers: any = [
    { text: 'Módulo', value: 'nome', sortable: false, width: '200px' },
    { text: 'Acessos', value: 'descricao', sortable: false },
    { text: '', value: '', sortable: false, width: '30px' }
  ];

  mounted() {
    this.formOpen = true;
    this.loadProfilesAccessOptions();
    this.loadPermissions();
  }

  @Watch('id', { immediate: true })
  public onEditItemChanges(id: any) {
    if (!id) {
      return;
    }

    this.loader.start('Carregando...');
    service.getProfile(id).subscribe(
      (res) => {
        this.item = res;
        this.idsFuncsSelected = this.item.idsFuncsAcesso;
        this.loader.stop();
        this.loadFeaturesFuncionsSelected();
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
        this.$emit('close');
      }
    );
  }

  @Watch('item.tipo')
  public onChangeTypes(val): void {
    if (val == ACCESS_TYPE_CLIENT) {
      this.item.acessaTodosPerfis = false;
    }
    this.loadProfilesAccessOptions();
    this.loadPermissions();
  }

  public saveItem(): void {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    if (!this.idsFuncsSelected || !this.idsFuncsSelected.length) {
      this.toast.show('Selecione pelo menos um acesso', 'error');
      return;
    }

    this.loader.start('Salvando ...');

    let item = this.item;
    let parm = new PerfilParmDTO();
    parm.id = item.id;
    parm.descricao = item.descricao;
    parm.tipo = item.tipo;
    parm.ativo = item.ativo;
    parm.acessaTodosPerfis = item.acessaTodosPerfis;
    parm.idsPerfisPodeAcessar = item.idsPerfisPodeAcessar;
    parm.tipoLoginAcesso = item.tipoLoginAcesso;

    parm.idsFuncionalidades = this.idsFuncsSelected;

    let obs = !!parm.id ? service.updateProfile(parm) : service.saveProfile(parm);
    obs.subscribe(
      (res) => {
        this.toast.show('Perfil salvo com sucesso!', 'success');
        this.loader.stop();
        this.$emit('save');
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }

  public closeForm(): void {
    const closeAction = () => {
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction
    );
  }

  private loadPermissions(): void {
    this.loading = true;
    this.features = [];
    this.featuresNotSelected = [];
    this.featuresSelected = [];
    service.getProfileFeaturesOptions(this.item.tipo).subscribe(
      (res) => {
        res = res.map((r) => {
          let dto = {
            ...r,
            selectAll: false
          };
          return dto;
        });
        this.loading = false;
        this.features = res;
        this.featuresNotSelected = res;
        this.loadFeaturesFuncionsSelected();
      },
      (error) => {
        this.loading = false;
        this.showToastApiError(error);
      }
    );
  }

  onFeatureSelectingChange(v) {
    this.featuresSelected.push(v);
    this.featuresNotSelected.splice(
      this.featuresNotSelected.findIndex((f) => f.id == v.id),
      1
    );
    let idsFuncs = v.funcionalidades.filter((f) => f.padraoRecurso).map((f) => f.id);
    idsFuncs.forEach((id) => {
      this.idsFuncsSelected.push(id);
    });

    setTimeout(() => {
      this.featureSelecting = null;
    }, 300);
  }

  removeFeature(item) {
    this.featuresNotSelected.push(item);
    this.featuresSelected.splice(
      this.featuresSelected.findIndex((f) => f.id == item.id),
      1
    );
    let idsFuncs = item.funcionalidades.map((f) => f.id);
    this.idsFuncsSelected = this.idsFuncsSelected.filter((id) => idsFuncs.findIndex((f) => f == id) == -1);
    this.featuresNotSelected.sort((o1, o2) => (o1.nome < o2.nome ? -1 : 1));
  }

  checkAll(checked, feature) {
    if (checked) {
      feature.funcionalidades.forEach((f) => {
        if (this.idsFuncsSelected.findIndex((id) => id == f.id) == -1) {
          this.idsFuncsSelected.push(f.id);
        }
      });
    } else {
      this.idsFuncsSelected = this.idsFuncsSelected.filter(
        (id) => feature.funcionalidades.findIndex((f) => f.id == id && !f.padraoRecurso) == -1
      );
    }
  }

  setCheckedAllValue(feature) {
    feature.selectAll = feature.funcionalidades.every((f) => this.idsFuncsSelected.findIndex((id) => f.id == id) != -1);
  }

  loadFeaturesFuncionsSelected() {
    if (!this.features) {
      return;
    }
    if (!this.item) {
      return;
    }
    this.featuresSelected = this.features.filter((r) =>
      r.funcionalidades.some((f) => this.idsFuncsSelected.some((id) => id == f.id))
    );
    this.featuresNotSelected = this.features.filter(
      (r) => !r.funcionalidades.some((f) => this.idsFuncsSelected.some((id) => id == f.id))
    );

    this.featuresSelected.forEach((f) => {
      this.setCheckedAllValue(f);
    });
  }

  loadProfilesAccessOptions() {
    service.getProfileProfilesAccessOptions(this.item.tipo).subscribe(
      (res) => {
        this.profilesAccessOptions = res;
        if (!!this.item && !!this.item.idsPerfisPodeAcessar && !!this.item.idsPerfisPodeAcessar.length) {
          this.item.idsPerfisPodeAcessar = this.profilesAccessOptions
            .filter((p) => this.item.idsPerfisPodeAcessar.some((id) => p.id == id))
            .map((p) => p.id);
        }
      },
      (error) => {
        this.showToastApiError(error);
      }
    );
  }
}
